export const env = "prod";
export const sendemailnsms = "https://lg6qtrhsf5.execute-api.ap-south-1.amazonaws.com/sendemailnsms";
export const otpMobileSendDev = "https://jtb1gx7p8l.execute-api.ap-south-1.amazonaws.com/otpMobileSendDev";
export const sendparentalconsent = "https://ceropnoge3.execute-api.ap-south-1.amazonaws.com/sendparentalconsent";
export const otpvarify = "https://zi1lq4olk9.execute-api.ap-south-1.amazonaws.com/otpvarify";
export const getparentalconsent = "https://8x0l6n4tca.execute-api.ap-south-1.amazonaws.com/getparental_consent";
export const getUserProfileImage = "https://888rmx56ng.execute-api.ap-south-1.amazonaws.com/default/getUserProfileImage";
export const welcomeemail= "https://vv4pst9ox7.execute-api.ap-south-1.amazonaws.com/welcomeemail";
export const selfemailverification="https://0xx9mfwfqk.execute-api.ap-south-1.amazonaws.com/selfemailverification";
export const mbileverificationreminder ="https://hwalxgciig.execute-api.ap-south-1.amazonaws.com/mbileverificationreminder";
export const userinvitation="https://t5imomhhbi.execute-api.ap-south-1.amazonaws.com/userinvitation/";
export const smarttech = "https://ddedwz07tc.execute-api.ap-south-1.amazonaws.com/smarttehuser/";
export const notification="https://nlerubfldd.execute-api.ap-south-1.amazonaws.com/notification/";

export const connectionrequestsent ="https://mryf7ohthh.execute-api.ap-south-1.amazonaws.com/connectionrequestsent"
export const connectionrequestaccept ="https://u4hgdgu462.execute-api.ap-south-1.amazonaws.com/connectionrequestaccept"
export const pdfConverter ="https://5nrsw9myja.execute-api.ap-south-1.amazonaws.com/pdfConverterNew"
export const moodleToken = "ecef2b807ad2669e7e57b4104efb0217"
export const baseURL = window.location.origin
export const moodleAppBaseUrl = baseURL !== "https://www.mysphere.net" ? "https://devstemclip.mysphere.net/" : "https://stemclip.mysphere.net/";
export const moodleApiUrl = `${moodleAppBaseUrl}/webservice/rest/server.php`
export const assessmentBaseUrl =  baseURL !== "https://www.mysphere.net" ? "https://d3miq8k3kfqo5s.cloudfront.net" : "https://d3awjl27jexv21.cloudfront.net";
export const s3CloudFrontUrl = baseURL !== "https://www.mysphere.net" ? "https://dtmqd85q4ygtb.cloudfront.net" : "https://d35psbb0poemi8.cloudfront.net";
// export const s3CloudFrontUrl = "https://dtmqd85q4ygtb.cloudfront.net"
export const cloudfrontKeyPairId = "K3CCL7F81MS5XB";
export const appLink = baseURL === "https://www.mysphere.net" ? "https://www.mysphere.net/" : baseURL === "https://dev.mysphere.net" ? "https://dev.mysphere.net/" : "http://localhost:3000/";
export const mysphereAPIURL =  baseURL === "https://www.mysphere.net" ? "https://api.mysphere.net" : baseURL === "http://localhost:3000" ? "http://localhost:9000" : "https://apidev.mysphere.net";
export const googleClientId = baseURL === "https://www.mysphere.net" ? "512254333973-ms4l9tmop2ib85jhblvubg8e81ikcq78.apps.googleusercontent.com" : "240246132475-12d1bhnpo9btim7t5d9dkqmcjg9c1ef6.apps.googleusercontent.com";
export const AIChatTypes = {
    SKILL_JOURNEY: "skill_journey",
    SELF_JOURNEY: "self_journey",
    PDF_ASSESSMENT: "pdf_assessment",
    ORG_COHORT_PDF_ASSESSMENT: "org_cohort_pdf_assessment",
}
export const QuestionTypes = {
    SINGLE_CHOICE_MCQ: "single_choice_mcq",
    SHORT_ANSWER: "short_answer",
}    
export const organizationTypes = {
    SCHOOL: "SCHOOL",
    COLLEGE: "COLLEGE",
    CORPORATE: "CORPORATE",
}
export const CompetitionStatus = {
    DRAFT: 'DRAFT',
    UPCOMING: 'UPCOMING',
    ONGOING: 'ONGOING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};

export const logoSize = 512;


//Moodle course mnemonics
export const GRADE_CODES = {
"01": "1",
"02": "2",
"03": "3",
"04": "4",
"05": "5",
"06": "6",
"07": "7",
"08": "8",
"09": "9",
10: "10",
11: "11",
12: "12",
};
export const BOARD_CODES = {
0: "All",
1: "CBSC",
2: "ICSE",
3: "IGCSE",
4: "IB",
5: "SSC",
};
export const LANG_CODES = {
EN: "English",
HI: "Hindi",
MR: "Marathi",
GU: "Gujarati",
BN: "Bengali",
TA: "Tamil",
KA: "Kannada",
ML: "Malayalam",
};
export const PLAN_CODES = {
T: "Teacher only",
B: "Teacher + Student",
S: "Student Self Study",
};
export const SUBJECT_CODES = {
DTN: "Design Thinking",
LRo: "Jr Robotics",
ELC: "Electronics",
"3DP": "PD and 3D Printing",
IoT: "Internet of Things",
ARC: "Architecture and Interior Design",
DCh: "Design Challenges",
VEl: "Virtual Electronics", //not in updated course code sheet
VRo: "Senior Robotics (Virtual)",
ARo: "Senior Robotics (Arduino)",
CUN: "Coding Unplugged",
CAG: "Coding Animations",
GAM: "Game development with AI/ML",
AIU: "AI Unplugged",
AIM: "Artificial Intelligence & Machine Learning", //not in updated course code sheet
MLP: "Machine Learning and Advanced Python",
CAD: "Coding App development",
WEB: "Website design",
AIB: "AI with Block Programming",
DAP: "Data Analysis with python programming",
PBP: "Python based Projects",
IPy: "Introduction To Python programming",
SCN: "Science",
MTH: "Mathematics",
ICT: "ICT",
ERo: "Electronic and Robotics - Beginner",
ERC: "Robotics using Curobot",
CEL: "Block Coding with Electronics (C&S)",
SDG: "Sustainable Development Goals",
AIR: "AI Robotics (CG AI Bot)",
AIP: "AI using Python",
DYE: "DIY Electronics",
};
export const PACKAGE_CODES = {
DM: "Discoverers",
CM: "Coders",
MM: "Makers",
};
export const CLIENT_TO_MASTER = {
5: "112",
8: "118",
58: "115",
};